import React, { PureComponent } from 'react';

export default class FraudAdvisory extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className='p-t-b-100'>
        <div className='row'>
          <div className='col-10 offset-1'>
            <h1 className='text-dark'>Fraud Advisory</h1>
            <h2 className='mt-5'>Protect Yourself Against Fake Job Offers</h2>
            <p>
              At Awign Expert, we take the security and well-being of our community members seriously. As a work-as-a-service provider, we are committed to maintaining a safe and
              trustworthy platform for connecting high-skilled white-collared professionals with global multinational companies. In light of recent incidents of fraudulent
              activities in the job market, we want to ensure that you are equipped with the knowledge to identify and protect yourself against fake job offers and interview
              malpractices.
            </p>
            <h3 className='my-4'>1. Beware of Fake Job Offers:</h3>
            <p>
              Scammers may impersonate reputable companies, including Awign Expert, and send fake job offers via email, social media, or other channels. To safeguard yourself
              against such scams, keep the following points in mind:
            </p>
            <p>
              a. Verify the Email Domain: Our official email address for communication is expert@awign.com. Be cautious if you receive job offers from email addresses that seem
              suspicious or do not match our official domain.
            </p>
            <p>
              b. Check for Typos and Errors: Legitimate companies take care in crafting their communication. Watch out for typos, grammatical errors, and inconsistent formatting in
              job offers.
            </p>
            <p>
              c. Never Pay for a Job: Awign Expert or any legitimate employer will never ask you to pay any fees for a job offer. If someone requests payment for a job opportunity,
              it is likely a scam.
            </p>
            <h3 className='my-4'>2. Identify Interview Malpractices:</h3>
            <p>Interview malpractices can be deceptive and may aim to extract personal information or money from job seekers. Stay vigilant against these practices:</p>
            <p>
              a. Video Interview Scams: If you are invited to a video interview, ensure that it is conducted through a secure and reputable platform. Be cautious if asked to
              install unfamiliar software or share personal information during the interview process.
            </p>
            <p>
              b. Phishing Attempts: Watch out for phishing emails or messages claiming to be from Awign Expert. These may request sensitive information or direct you to malicious
              websites.
            </p>
            <p>
              c. Fake Assessments: Scammers may conduct fake assessments, pretending to be part of our hiring process. Always verify the legitimacy of any assessment before
              participating.
            </p>
            <h3 className='my-4'>3. Report Suspicious Activity:</h3>
            <p>
              If you come across any suspicious job offers, interview malpractices, or communication that appears fraudulent, please report it to us immediately. You can contact
              our support team at expert@awign.com or use the appropriate reporting feature on our website.
            </p>
            <h3 className='my-4'>4. Protect Your Personal Information:</h3>
            <p>
              Never share sensitive personal information, such as your AADHAR, PAN number, bank details, or passport information, unless you are sure about the legitimacy of the
              request and the organization.
            </p>
            <p>
              We are committed to maintaining the trust and security of our users. By staying informed and vigilant, we can work together to create a safe environment for all
              members of the Awign Expert community.
            </p>
            <p>
              If you have any concerns or questions regarding job offers or interview practices, please do not hesitate to reach out to us. Your safety and security are our top
              priorities.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
